import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import ApplyNowButton from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/ApplyNowButton';
import CardImage from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/CardImage';
import RatesAndFeesButton from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/RatesAndFeesButton';
import ApplyNowTitle from '../../components/ApplyNowTitle';
import { useSidebarCallbacks } from '../../hooks';
export default function MobileProductCardHeader(t0) {
  const $ = _c(23);
  const {
    image,
    showCTA,
    thinTitle
  } = t0;
  const {
    resizable: resizableImage,
    small: smallImage
  } = image;
  const {
    containerRef
  } = useSidebarCallbacks();
  let t1;
  if ($[0] !== resizableImage || $[1] !== smallImage.url || $[2] !== smallImage.width) {
    t1 = customImageWidthURLBuilder(resizableImage, {
      customImageWidth: smallImage.width,
      customImageQuality: 80,
      imageParentWidth: 180
    }, smallImage.url);
    $[0] = resizableImage;
    $[1] = smallImage.url;
    $[2] = smallImage.width;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    optimized
  } = t1;
  let t2;
  if ($[4] !== optimized.parentElement.height || $[5] !== optimized.parentElement.width) {
    t2 = {
      position: "relative",
      height: optimized.parentElement.height,
      width: optimized.parentElement.width
    };
    $[4] = optimized.parentElement.height;
    $[5] = optimized.parentElement.width;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== optimized.image.url) {
    t3 = <CardImage source={optimized.image.url} />;
    $[7] = optimized.image.url;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Grid sx={t2}>{t3}</Grid>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== optimized.parentElement.width || $[13] !== showCTA) {
    t5 = showCTA && <Grid pb={3.5} textAlign="center" justifyContent="center"><Box display="flex" flexDirection="column" width={optimized.parentElement.width}><ApplyNowButton device="mobile" /><RatesAndFeesButton /></Box></Grid>;
    $[12] = optimized.parentElement.width;
    $[13] = showCTA;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== showCTA || $[16] !== thinTitle) {
    t6 = <Grid><ApplyNowTitle showCTA={showCTA} thinTitle={thinTitle} /></Grid>;
    $[15] = showCTA;
    $[16] = thinTitle;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== containerRef || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <Grid container={true} pt={3.5} px={3.5} rowGap={2} alignItems="center" flexDirection="column" ref={containerRef}>{t4}{t5}{t6}</Grid>;
    $[18] = containerRef;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}